import React from 'react'
import './Product_Description_Text.css'

const Product_Description_Text = (props) => {
  return (
    <div className='Product_Description_Text'>
      <p className='heading'>Description</p>

      <div className='text_holder'>
        <p>{props?.description}</p>
      </div>
    </div>
  )
}

export default Product_Description_Text
